import { isInactiveStatus } from "@/features/appointments/utils";
import { useActiveProject } from "@/features/project/ActiveProject";
import { useProjectQuestionnaire } from "@/features/project/useProjectQuestionnaire";
import { useAnswers } from "@/features/questionnaire/AnswersProvider";
import {
  BOKA_TAB_KEY,
  QuestionnaireGroup,
  type QuestionnaireGroupProps,
} from "@/features/questionnaire/QuestionnaireGroup";
import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet } from "@repo/ui";
import { useEffect, useState } from "react";

export interface QuestionnaireModalProps extends QuestionnaireGroupProps {
  isOpen: boolean;
  closeModal: () => void;
  opportunityId: number;
}

export const QuestionnaireModal = ({
  isOpen,
  closeModal,
  selectedHfbs,
  service,
}: QuestionnaireModalProps) => {
  const { opportunity } = useActiveProject();
  const { answers, b2bAnswers, updateAnswers, updateB2bAnswers } = useAnswers();
  const {
    isSaving,
    saveAnswer,
    saveB2bAnswers,
    answersData,
    b2bAnswersData,
    bokaQuestionnaire,
    bokaTokenUrl,
    selectedStatus,
  } = useProjectQuestionnaire();
  const [currentTab, setCurrentTab] = useState<string>();
  const customerProjects = opportunity?.customerProjects;

  useEffect(() => {
    if (
      answersData?.answers !== undefined ||
      b2bAnswersData?.answers !== undefined
    ) {
      updateAnswers(answersData?.answers ?? []);
      updateB2bAnswers(b2bAnswersData?.answers ?? []);
    }
  }, [answersData, b2bAnswersData, updateAnswers, updateB2bAnswers]);

  const handleSave = async () => {
    if (currentTab === "B2B") {
      await saveB2bAnswers(b2bAnswers);
    } else {
      await saveAnswer(answers);
    }
    closeModal();
  };

  return (
    <ModalSheet
      title={t("label.questionnaires")}
      visible={isOpen}
      onClose={closeModal}
      footer={
        currentTab === BOKA_TAB_KEY ? (
          bokaTokenUrl ? (
            <Button
              text={t("action.update_answers")}
              onClick={() =>
                window.open(bokaTokenUrl, "_blank", "noopener,noreferrer")
              }
              type="primary"
              disabled={isInactiveStatus(selectedStatus)}
            />
          ) : null
        ) : (
          <Button
            text={t("action.save")}
            onClick={handleSave}
            type="primary"
            loading={isSaving}
          />
        )
      }
    >
      <QuestionnaireGroup
        selectedHfbs={selectedHfbs}
        service={service}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        showB2BTab={customerProjects && customerProjects.length > 0}
        bokaQuestionnaire={bokaQuestionnaire}
      />
    </ModalSheet>
  );
};
